import React, { Component } from "react";
import {
  reduxForm,
  change,
  submit as submitForm,
  formValueSelector,
} from "redux-form";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from 'classnames';

import submit from "../../SearchForm/submit";

import s from "./HomeTypeSlider.css";


class HomeTypeSlider extends Component {

  handleSubmitButton = async (e) => {
    const { handleSubmit } = this.props;
    const { change } = this.props;
    let roomType = [];
    roomType?.push(e);

    await change('isActiveRoomType', e)
    await change("roomType", roomType);
    await change("currentPage", 1);
    await handleSubmit();
    window.scrollTo({
      top: 0,
      left: 0
    });
  }

  render() {
    const { roomType, isActiveRoomType, className } = this.props;

    return (
      <div className={className}>
        {
          roomType?.length > 0 && roomType?.filter((enableItem) => enableItem.isEnable == '1')
            .filter((item) => item.listingCount > 0)
            .map((item, key) => {
              return (
                <div
                  key={key}
                  onClick={() => this.handleSubmitButton(item?.id)}
                  className={cx(s.chip, { [s.chipActive]: item?.id == isActiveRoomType })}
                >
                  {item?.itemName}
                </div>
              )
            })
        }
      </div>
    );
  }
}

HomeTypeSlider = reduxForm({
  form: "SearchForm",
  onSubmit: submit,
  destroyOnUnmount: false,
})(HomeTypeSlider);

const selector = formValueSelector('SearchForm')

const mapState = (state) => ({
  isActiveRoomType: selector(state, 'isActiveRoomType'),
  updatedLocale: state?.intl?.newLocale,
});

const mapDispatch = {
  change,
  submitForm,
};

export default injectIntl(
  withStyles(s)(connect(mapState, mapDispatch)(HomeTypeSlider))
);
